export const SET_FILTERITEMS = 'SET_FILTERITEMS';
export const SET_TEMPFILTERITEMS = 'SET_TEMPFILTERITEMS';
export const SET_SORTLISTBY = 'SET_SORTLISTBY';
export const SET_TAGLIST = 'SET_TAGLIST';
export const SET_SWITCHLISTBY = 'SET_SWITCHLISTBY';

// search/GroupListInfoJson (取得熱銷與一般行程)

export const SET_PAGESIZEM = 'SET_PAGESIZEM';
// 全產品
export const GET_DATA = 'GET_DATA';
export const SET_RECOMMENDS = 'SET_RECOMMENDS';

// 全產品card內容設置
export const SET_CITYLENGTH = 'SET_CITYLENGTH';
export const SET_CARDINFO = 'SET_CARDINFO';
export const SET_FAVLIST = 'SET_FAVLIST';
export const SET_FAVPOPUP = 'SET_FAVPOPUP';
export const SET_SHOWFAVPOPUP = 'SET_SHOWFAVPOPUP';
export const SET_HIDEFAVPOPUP = 'SET_HIDEFAVPOPUP';
export const SET_MOBILE_EMIT_API = 'SET_MOBILE_EMIT_API';
export const SET_FILTERDATALOADING = 'SET_FILTERDATALOADING';
